import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Users, Sparkles, ChevronRight } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Home() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    api.get("/chats").then((r) => setRecent((r.data || []).slice(0, 4))).catch(() => {});
  }, []);

  const first = (user?.name || "there").split(" ")[0];

  return (
    <div className="mx-auto max-w-3xl px-5 py-8" data-testid="home-page">
      <h1 className="font-display text-3xl text-[#F4F1EA]">Hi {first}</h1>
      <p className="mt-1 text-sm text-[#8C8578]">Choose how you want to talk tonight.</p>

      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        <motion.button
          whileTap={{ scale: 0.98 }}
          data-testid="home-meet-real"
          onClick={() => navigate("/app/match")}
          className="group rounded-2xl border border-[#2B241B] bg-gradient-to-br from-[#17130D] to-[#12100E] p-6 text-left transition-colors hover:border-[#D4AF37]/50"
        >
          <Users className="mb-4 h-7 w-7 text-[#D4AF37]" />
          <h2 className="font-display text-xl text-[#F4F1EA]">Meet Someone Real</h2>
          <p className="mt-1 text-sm text-[#C8C2B5]">Get matched anonymously with another active adult. No profiles, no photos.</p>
          <span className="mt-4 inline-flex items-center gap-1 text-sm text-[#D4AF37]">Start <ChevronRight className="h-4 w-4" /></span>
        </motion.button>

        <motion.button
          whileTap={{ scale: 0.98 }}
          data-testid="home-meet-ai"
          onClick={() => navigate("/app/discover")}
          className="group rounded-2xl border border-[#2B241B] bg-gradient-to-br from-[#17130D] to-[#12100E] p-6 text-left transition-colors hover:border-[#D4AF37]/50"
        >
          <Sparkles className="mb-4 h-7 w-7 text-[#D4AF37]" />
          <div className="flex items-center gap-2">
            <h2 className="font-display text-xl text-[#F4F1EA]">Meet an AI Persona</h2>
            <span className="rounded-full bg-[#24201C] px-2 py-0.5 text-[10px] uppercase tracking-wider text-[#D4AF37]">AI persona</span>
          </div>
          <p className="mt-1 text-sm text-[#C8C2B5]">Talk with a clearly-labelled fictional AI adult. A fresh Mystery Match every time.</p>
          <span className="mt-4 inline-flex items-center gap-1 text-sm text-[#D4AF37]">Discover <ChevronRight className="h-4 w-4" /></span>
        </motion.button>
      </div>

      {recent.length > 0 && (
        <div className="mt-8">
          <h3 className="mb-3 text-sm font-semibold uppercase tracking-wider text-[#8C8578]">Recent conversations</h3>
          <div className="space-y-2">
            {recent.map((c) => (
              <button
                key={c.character.id}
                onClick={() => navigate(`/app/chat/${c.character.id}`)}
                className="flex w-full items-center gap-3 rounded-xl border border-[#2B241B] bg-[#12100E] p-3 text-left hover:border-[#D4AF37]/40"
              >
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#24201C] text-sm text-[#D4AF37]">
                  {(c.character.name || "?")[0]}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <p className="truncate text-sm text-[#F4F1EA]">{c.character.name}</p>
                    <span className="rounded bg-[#24201C] px-1.5 py-0.5 text-[9px] uppercase tracking-wider text-[#D4AF37]">AI persona</span>
                  </div>
                  <p className="truncate text-xs text-[#8C8578]">{c.preview || "Say hello"}</p>
                </div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
